// Domain entities for error handling
/**
 * Error thrown when navigation to error page interrupts normal flow
 * This error should be caught and silently handled in components
 */
export class NavigationInterruptError extends Error {
    constructor(message) {
        super(message ?? "Navigation interrupted - error page navigation in progress");
        this.name = "NavigationInterruptError";
        // Maintains proper stack trace for where our error was thrown (only available on V8)
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, NavigationInterruptError);
        }
    }
}
